import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatTableModule } from '@angular/material/table'
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-finance',
  templateUrl: './finance.component.html',
  styleUrls: ['./finance.component.css']

})

export class FinanceComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(private spinner: NgxSpinnerService) {

  }

  year_L = [    //รายการปี    
    { "yearTh": "6667", "yearCr": "2324", "yearDesc": "ปี 2566/2567", "status": 0 },
    { "yearTh": "6768", "yearCr": "2425", "yearDesc": "ปี 2567/2568", "status": 1 },
    { "yearTh": "6869", "yearCr": "2526", "yearDesc": "ปี 2568/2569", "status": 0 }
  ]
  year_S = [];

  ngOnInit(): void {
    this.year_S = this.year_L.filter((el: any) => el.status == 1);
    this.LoaddataDashboard();
  }

  ngOnDestroy() {
    this.datadashboard = null;
  }

  test = false;
  showdata() {
    console.log(this.test);
    this.test = !this.test;
  }
  displaydatausedall = ['num', 'timeline', 'zone', 'docid', 'date', 'code', 'fullname', 'titile', 'count', 'status'];
  Alldata: any = [];
  toonedata: any;

  GetDAta(fncode: any, data: any) {
    this.toonedata = data;
    let bycode = (data.filter(el => el.fncode == fncode));
    this.Alldata = new MatTableDataSource(bycode);
    this.Alldata.paginator = this.paginator;
    this.Alldata.sort = this.sort;
    //console.log(this.Alldata);
  }



  applyFilter2(event: Event) {
    const filterValue2 = (event.target as HTMLInputElement).value;
    this.Alldata.filter = filterValue2.trim().toLowerCase();;
    if (this.Alldata.paginator) {
      this.Alldata.paginator.firstPage();
    }
  }

  // ข้อมูลตัวเลขหน้าหลัก
  datadashboard: any;
  sumall: any = [];
  LoaddataDashboard() {
    let year = this.year_S[0];
    this.spinner.show();
    this.sumall = [];
    axios.get(`https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_fncode_${year.yearTh}]&w=1=1`)
      .then(res => {
        this.spinner.hide();
        this.datadashboard = (res.data);
        this.datadashboard.sort(function (a: any, b: any) { return a.num - b.num });
        this.sumall.push({
          cntall: (this.datadashboard.map(el => { return el.cntall }).reduce((a, b) => a + b, 0))
          , cntCday: (this.datadashboard.map(el => { return el.cntCday }).reduce((a, b) => a + b, 0))
          , cntCMonth: (this.datadashboard.map(el => { return el.cntCMonth }).reduce((a, b) => a + b, 0))
          , cntA: (this.datadashboard.map(el => { return el.cntA }).reduce((a, b) => a + b, 0))

          , allcnt1: (this.datadashboard.map(el => { return el.cnt1 }).reduce((a, b) => a + b, 0))
          , allcnt7: (this.datadashboard.map(el => { return el.cnt7 }).reduce((a, b) => a + b, 0))
          , allcnt8: (this.datadashboard.map(el => { return el.cnt8 }).reduce((a, b) => a + b, 0))
          , allcnt9: (this.datadashboard.map(el => { return el.cnt9 }).reduce((a, b) => a + b, 0))
          , allcnt4: (this.datadashboard.map(el => { return el.cnt4 }).reduce((a, b) => a + b, 0))

          , cntCd_s1: (this.datadashboard.map(el => { return el.cntCd_s1 }).reduce((a, b) => a + b, 0))
          , cntCd_s7: (this.datadashboard.map(el => { return el.cntCd_s7 }).reduce((a, b) => a + b, 0))
          , cntCd_s8: (this.datadashboard.map(el => { return el.cntCd_s8 }).reduce((a, b) => a + b, 0))
          , cntCd_s9: (this.datadashboard.map(el => { return el.cntCd_s9 }).reduce((a, b) => a + b, 0))
          , cntCd_s4: (this.datadashboard.map(el => { return el.cntCd_s4 }).reduce((a, b) => a + b, 0))
        });
      }).catch(err => { throw (err); });


  }

  managerzonedata = [];
  financedata = [];
  Hfinancedata = [];
  adjfinancedata = [];
  Mfinancedata = [];
  Acceptfinancedata = [];
  loadDatalist(status: string) {
    let year = this.year_S[0];
    axios.get(`https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfinance6667]&w=doc_status='${status}'`)
      .then(res => {
        let data = res.data;
        if (status == '0') {// ข้อมูลโดยผจก.โซน
          this.managerzonedata = data;
        }
        else if (status == '1') {// ข้อมูลโดยพนักงานสินเชื่อ
          this.financedata = data;
        }
        else if (status == '7') {// ข้อมูลโดยผู้ช่วยผจกสินเชื่อ
          this.Hfinancedata = data;
        }
        else if (status == '8') {// ข้อมูลโดยผู้จัดการงานสินเชื่อ
          this.adjfinancedata = data;
        }
        else if (status == '9') { // ข้อมูลโดยผู้ช่วยผจกสินเชื่อ
          this.Mfinancedata = data;
        }
        else if (status == '4') {// ข้อมูลอนุมัติงานสินเชื่อ
          this.Acceptfinancedata = data;
        }
      }).catch(err => { throw (err); });
  }
  /*// ข้อมูลโดยผจก.โซน
  managerzonedata: any;
  LoaddatadashboardBy0() {
    axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfinance6667]&w=doc_status='0'")
      .then(res => {
        this.managerzonedata = res.data;
      }).catch(err => { throw (err); });
  }

  // ข้อมูลโดยพนักงานสินเชื่อ
  financedata: any;
  LoaddatadashboardBy1() {
    axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfinance6667]&w=doc_status='1'")
      .then(res => {
        this.financedata = res.data;
      }).catch(err => { throw (err); });
  }
  // ข้อมูลโดยหัวหน้างานสินเชื่อ
  Hfinancedata: any;
  LoaddatadashboardBy7() {
    axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfinance6667]&w=doc_status='7'")
      .then(res => {
        this.Hfinancedata = res.data;
      }).catch(err => { throw (err); });
  }
  // ข้อมูลโดยผู้ช่วยผจกสินเชื่อ
  adjfinancedata: any;
  LoaddatadashboardBy8() {
    axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfinance6667]&w=doc_status='8'")
      .then(res => {
        this.adjfinancedata = res.data;
      }).catch(err => { throw (err); });
  }

  // ข้อมูลโดยผู้จัดการงานสินเชื่อ
  Mfinancedata: any;
  LoaddatadashboardBy9() {
    axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfinance6667]&w=doc_status='9'")
      .then(res => {
        this.Mfinancedata = res.data;
      }).catch(err => { throw (err); });
  }

  // ข้อมูลอนุมัติงานสินเชื่อ
  Acceptfinancedata: any;
  LoaddatadashboardBy4() {
    axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfinance6667]&w=doc_status='4'")
      .then(res => {
        this.Acceptfinancedata = res.data;
      }).catch(err => { throw (err); });
  }*/

  THtoLocalstring(value: any) {
    if (!value) {
      return '';
    }
    const date1 = new Date(value);
    let options: any = {
      // weekday: "short",
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZone: 'UTC'
    };

    return date1.toLocaleString('th-TH', options);
  }

  // ข้อมูลใน Modal
  datainmodal: any;
  Datainmodel(docid: any) {
    this.datainmodal = this.toonedata.filter(el => el.docid == docid);
  }

  OnDestroy() {
    this.datadashboard = null;
    this.Acceptfinancedata = null;
    this.Hfinancedata = null;
    this.Mfinancedata = null;
    this.managerzonedata = null;
    this.sumall = null;
    this.datainmodal = null;
  }
}


